import { baseURL } from '..';
import { ISoil } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { IGetSoilPreviewResponse } from './iApiResponse';

const soilProvider = () => {
    const getSoilByIdAsync = async (id: number): Promise<IResponse<ISoil>> => httpClient.getAsync(createRequest(baseURL, `/Soil/GetSoilById?id=${id}`), createHeaders());

    const updateSoilAsync = async (payload: ISoil): Promise<IResponse<ISoil>> => httpClient.putAsync(createRequest(baseURL, '/Soil/UpdateSoil', payload), createHeaders());

    const insertSoilAsync = async (payload: ISoil): Promise<IResponse<ISoil>> => httpClient.postAsync(createRequest(baseURL, '/Soil/InsertSoil', payload), createHeaders());

    const getAllSoilAsync = async (): Promise<IResponse<ISoil[]>> => httpClient.getAsync(createRequest(baseURL, '/Soil/GetAllSoil'), createHeaders());

    const getPaginatedSoilPreviewsAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IGetSoilPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Soil/GetPaginatedSoilPreviews', undefined, paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    return {
        getSoilByIdAsync,
        updateSoilAsync,
        insertSoilAsync,
        getPaginatedSoilPreviewsAsync,
        getAllSoilAsync,
    };
};

export default soilProvider();
